module.exports = __webpack_public_path__ + "pigmentace_4_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/pigmentace_4_after.jpg
// module id = 975
// module chunks = 0